import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-warning-reselect-sign-approver',
  templateUrl: './warning-reselect-sign-approver.component.html',
  styles: [`
    .info-branch {
      font-family: Roboto, "Helvetica Neue", sans-serif;
    }
  `]
})
export class WarningReselectSignApproverComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WarningReselectSignApproverComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string,
    private dialog: MatDialog,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  reason: string = '';
  formChangesSubscription: Subscription;
  @ViewChild('f', {static: false}) ngForm: NgForm;

  private isFormChanging: any;

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close(false);
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  confirm() {
    this.dialogRef.close(this.reason);
  }

}
